import React from "react";

interface CategoryButtonProps {
  name: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  isActive: boolean;
  onClick: () => void;
}

const CategoryButton: React.FC<CategoryButtonProps> = ({
  name,
  Icon,
  isActive,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex-shrink-0 flex items-center h-9 px-3 rounded-full transition-all duration-300 transform hover:scale-105 ${
        isActive
          ? "bg-primary text-white shadow-glow-primary"
          : "bg-gray-100 text-gray-800 hover:bg-gray-200"
      }`}
      aria-pressed={isActive}
    >
      <Icon
        className={`w-5 h-5 mr-2 transition-colors ${isActive ? "text-white" : "text-primary"}`}
      />
      <span className="font-bold text-sm">{name}</span>
    </button>
  );
};

export default CategoryButton;
